import React from 'react';
import BudgetGrid from '../BudgetGrid';
import SubmitBudgetButton from '../../components/SubmitBudgetButton';

// =============================================================================
// Module budget entry — the OPEX capture grid, scoped to one module.
//
// A GL line's `source_module` decides which screen owns it:
//   MOD_1_OPEX  -> Opex Budget Capture
//   MOD_3_MAKE  -> Manufacturing > Fixed Costs
//   MOD_4_MOVE  -> Distribution > Fixed Costs
// Set it on Budget Setup > GL Lines. A line with no module set counts as OPEX,
// so nothing captured before the field existed goes missing.
//
// Every screen is the SAME grid — same drill-down, same Manual/PxQ build, same
// role and site filtering — differing only in which lines it shows.
// =============================================================================

const ModuleBudgetEntry = ({ title, description, module: moduleCode, submitModule }) => (
  <div className="p-6 h-full flex flex-col overflow-hidden bg-slate-100 dark:bg-slate-900">
    <div className="shrink-0 mb-4 flex items-start justify-between gap-4">
      <div>
        <h2 className="m-0 text-2xl font-bold text-slate-900 dark:text-slate-100">{title}</h2>
        <p className="m-0 mt-1 text-slate-500 dark:text-slate-400">{description}</p>
      </div>
      <SubmitBudgetButton module={submitModule || moduleCode} />
    </div>
    <div className="flex-1 min-h-0">
      <BudgetGrid module={moduleCode} />
    </div>
  </div>
);

export default ModuleBudgetEntry;
